import { h } from "preact";
import { classNames } from "../helpers";

import i18n from "../i18n";

export default function ErrorState({ fullGrid, children }) {
  let mainDivClass = "col s12";
  let imgDivClass = "col s12 l10 push-l1 center mb-48";
  if (fullGrid) {
    mainDivClass = classNames(mainDivClass, "l8 push-l2");
    imgDivClass = "col s12 l8 push-l2 center mb-48";
  }
  return (
    <section class="row">
      <div class={classNames(mainDivClass, "mb-48")}>
        <h1 class="t-h5 t-h5--margin color-semantic-error">
          {i18n.t(`component.error_state.title`)}
        </h1>
        <p class="t-body3">{i18n.t(`component.error_state.description`)}</p>
      </div>

      <div class={imgDivClass}>
        <img
          src="/images/app_error_state.svg"
          style="width: 100%, max-width: 500px"
        />
      </div>
      <div class={mainDivClass}>{children}</div>
    </section>
  );
}
